__webpack_require__.p = "/gericht-restaurant/";